import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WebhookService } from './services';

@NgModule({
  imports: [CommonModule],
  providers: [WebhookService],
})
export class WebhooksWebModule {}
